import React from 'react'
import { Route, Routes } from "react-router-dom";

import VehicleMaintenanceListScreen from '../screens/App/CRM/VehicleMaintenance/VehicleMaintenanceListScreen';
import VehicleMaintenanceCreateScreen from '../screens/App/CRM/VehicleMaintenance/VehicleMaintenanceCreateScreen';
import VehicleMaintenanceEditScreen from '../screens/App/CRM/VehicleMaintenance/VehicleMaintenanceEditScreen';
import VehicleMaintenanceDetailScreen from '../screens/App/CRM/VehicleMaintenance/VehicleMaintenanceDetailScreen';


const VehicleMaintenanceRouter = () => {
    return (
        <Routes>
            <Route path="list" element={<VehicleMaintenanceListScreen />} />

             <Route path="create" element={<VehicleMaintenanceCreateScreen />} />

             <Route path=":id/edit" element={<VehicleMaintenanceEditScreen />} />

            <Route path=":id/detail" element={<VehicleMaintenanceDetailScreen />} />

        </Routes>
    )
}

export default VehicleMaintenanceRouter